import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { ComboboxSingleSelect } from '@eggplant/pattern-library'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type {
  GetRequirementStatusResponse,
  Options,
  TestStatus
} from '@eggplant/types'

interface Props {
  Icon?: ({ size }: { size: string }) => JSX.Element
  value?: string
  onChange: (value: TestStatus | string) => void
}

const url = MODELER_SERVICE + '/requirement_statuses'

const getStatusOptions = (data: GetRequirementStatusResponse): Options =>
  Object.keys(data).map(value => ({
    label: value[0].toUpperCase() + value.slice(1).toLowerCase(),
    value
  }))

const SelectRequirementsStatus = ({
  Icon,
  onChange,
  value
}: Props) =>
  <AuthenticatedDataRequest
    method='get'
    shortErrorMessage='Failed to load requirement status'
    url={url}
  >
    {
      ((data: GetRequirementStatusResponse) => {
        const statusOptions = getStatusOptions(data)

        return (
          <ComboboxSingleSelect
            Icon={Icon}
            isFilter
            isHighlighted={value !== ''}
            key={value}
            onChange={onChange}
            options={statusOptions}
            prompt='Requirement status'
            value={value}
          />
        )
      })
    }
  </AuthenticatedDataRequest>

export default SelectRequirementsStatus
